import { AddExtrasModal } from 'components/add-extras-modal';

export default function ExtrasCondimentsPage() {
  return <AddExtrasModal />;
}
